import { Box, Flex, Text } from '@chakra-ui/react';
import { motion } from 'motion/react';

export const MotionBox = motion.create(Box);
export const MotionFlex = motion.create(Flex);
export const MotionText = motion.create(Text);
